import React from "react";
import { Container } from "react-bootstrap";

import InViewWrapper from "../elements/InViewWrapper";
import { getBsColor } from "../../utilities/helpers";

const SectionHeader = ({
  title,
  titleColor,
  subtitle,
  subtitleColor,
  className,
  align,
  margin = "mb-5",
  isFirstSection,
}) => {
  if (!title && !subtitle) return null;

  // Check for all "falsy" values instead of just undefined of default params
  const al = align || "center";

  return (
    <Container
      as="header"
      className={`${margin || ""} text-${al} ${className || ""}`}
    >
      {title && (
        <InViewWrapper className="reveal reveal--bottom mb-3" amount={1} once>
          {isFirstSection ? (
            <h1 className={`mb-0 text-${getBsColor(titleColor || "blue")}`}>
              {title}
            </h1>
          ) : (
            <h2
              // eslint-disable-next-line prettier/prettier
              className={`type-subtitle mb-0 fw-bolder text-${getBsColor(titleColor || "blue")}`}
            >
              {title}
            </h2>
          )}
        </InViewWrapper>
      )}
      {subtitle && (
        <InViewWrapper
          className={`reveal reveal--${title ? "top" : "bottom"}`}
          amount={1}
          once
        >
          <h3 className={`type-title text-${getBsColor(subtitleColor)} mb-0`}>
            {subtitle}
          </h3>
        </InViewWrapper>
      )}
    </Container>
  );
};

export default SectionHeader;
